const news_filter = () => {
	const news = document.querySelector('.js-news-filter');
	if(news !== null){
		const href = location.href;
		const param = location.search;
		const year_link = document.querySelectorAll('.p-news__utility__set__list__item__link');
		const category_btn = document.querySelectorAll('.p-news__utility__set__list__item__btn');
		const item = document.querySelectorAll('.c-news__list__item');
		let category;

		// 年別
		year_link[0].href = '/news/';
		for (let i = 0; i < year_link.length; i++) {
			year_link[i].classList.remove('is-current');
			if(year_link[i].href == href){
				year_link[i].classList.add('is-current');
			}
		}

		// カテゴリー
		for (let i = 0; i < category_btn.length; i++) {
			category_btn[i].addEventListener('click', ()=>{
				category = category_btn[i].getAttribute('data-category');
				for (let j = 0; j < category_btn.length; j++) {
					category_btn[j].classList.remove('is-current');
				}
				category_btn[i].classList.add('is-current');

				if(category !== 'all'){
					for (let j = 0; j < item.length; j++) {
						item[j].style.display = 'none';
						if(item[j].getAttribute('data-category') === category){
							item[j].style.display = '';
						}
					}
				} else {
					for (let j = 0; j < item.length; j++) {
						item[j].style.display = '';
					}
				}
			});
		}

		if(param.indexOf('category') !== -1){
			category = param.split('=')[1];
			for (let i = 0; i < item.length; i++) {
				item[i].style.display = 'none';
				if(item[i].getAttribute('data-category') === category){
					item[i].style.display = '';
				}
			}
			for (let i = 0; i < category_btn.length; i++) {
				category_btn[i].classList.remove('is-current');
				if(category_btn[i].getAttribute('data-category') === category){
					category_btn[i].classList.add('is-current');
				}
			}
		}
		
	}
}